module.exports = __webpack_public_path__ + "static/media/texture-season-11.1907f788.jpg";